/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliInvitationPreviewDto } from '../../models/amoxcalli-invitation-preview-dto';

export interface ApiInvitationsPreviewGet$Json$Params {
  token?: string;
}

export function apiInvitationsPreviewGet$Json(http: HttpClient, rootUrl: string, params?: ApiInvitationsPreviewGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliInvitationPreviewDto>> {
  const rb = new RequestBuilder(rootUrl, apiInvitationsPreviewGet$Json.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliInvitationPreviewDto>;
    })
  );
}

apiInvitationsPreviewGet$Json.PATH = '/api/invitations/preview';
